import { useEffect, useContext } from "react";

import StepsPagination from "../Content/StepsPagination";
import StepsHeadline from "../Content/StepsHeadline";
import StepsForm from "../Content/StepsForm";
import HelperText from "../Content/HelperText";

import CalculatorContext from "../../Context/CalculatorContext";

/* eslint-disable max-len */
function StepFivePage() {
  const { setCurrentStepIndex, livingSpace, setLivingSpace } = useContext(CalculatorContext);

  useEffect(() => {
    setCurrentStepIndex(4);
  }, [setCurrentStepIndex]);

  return (
    <div className="tx-kalo form-steps-abwizard">
      <div className="frame frame-size-default frame-full frame-background-tertiary">
        <div className="frame-group-container">
          <div className="frame-container frame-container-default">
            <div className="frame-inner frame-inner-space-before-extra-small frame-inner-space-after-medium">
              <StepsPagination />

              <StepsHeadline>
                <h4 className="element-header text-center">
                  Bitte geben Sie die{" "}
                  <span className="text-primary">
                    Gesamtwohnfläche aller Wohnräume Ihrer Liegenschaft
                  </span>{" "}
                  an.
                </h4>
              </StepsHeadline>

              <div className="frame frame-size-default frame-indent-8 frame-space-after-extra-small">
                <div className="frame-container frame-container-default">
                  <div className="frame-inner">
                    <div className="tx-powermail">
                      <div className="wrap-fluid">
                        <StepsForm>
                          <fieldset className="powermail_fieldset">
                            <div className="row justify-content-center">
                              <div className="col-md-6 col-lg-5 text-center">
                                <fieldset className="form-group">
                                  <div className="powermail_fieldwrap">
                                    <div className="form-floating">
                                      <input
                                        aria-required="true"
                                        placeholder="Gesamtwohnfläche -  (m<sup>2</sup>)"
                                        className="form-control form-control-zip-custom powermail_input"
                                        id="living-space"
                                        type="number"
                                        required="required"
                                        pattern="\[0-9]*\.?\,?\d{2}"
                                        step={0.01}
                                        min={1}
                                        value={livingSpace}
                                        onKeyDown={(e) => {
                                          if (
                                            ![
                                              "0",
                                              "1",
                                              "2",
                                              "3",
                                              "4",
                                              "5",
                                              "6",
                                              "7",
                                              "8",
                                              "9",
                                              ",",
                                              ".",
                                              "Backspace",
                                            ].includes(e.key) ||
                                            [192, 229].includes(e.keyCode) ||
                                            (e.key === "0" && !livingSpace)
                                          ) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                          }
                                        }}
                                        onChange={(e) => {
                                          setLivingSpace(e.target.value);
                                        }}
                                      />

                                      <label htmlFor="living-space" title="">
                                        Gesamtwohnfläche (m<sup>2</sup>)
                                        <span className="mandatory">*</span>
                                      </label>
                                    </div>
                                  </div>
                                </fieldset>

                                <div className="form-group pt-3">
                                  <input
                                    className="btn btn-secondary"
                                    type="submit"
                                    value="Weiter"
                                    disabled={livingSpace === ""}
                                  />
                                </div>
                              </div>
                            </div>
                          </fieldset>
                        </StepsForm>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <HelperText>
                <p>
                  Bitte geben Sie an dieser Stelle die Wohnfläche aller Wohnräume in Ihrer
                  Liegenschaft an.
                </p>
              </HelperText>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StepFivePage;
